module.exports = __webpack_public_path__ + "images/62c64352c2248e5ff7b5b4ac52765c08b.svg";